import React from "react";
import { t } from "i18next";
import { CustomButton } from "components/Button";

function ChangeActionPopup({
  handleClickYes,
  handleClickNo,
  title,
  dynamicText,
}) {
  return (
    <div className="jsutify-center w-full items-center justify-center top-0 left-0 h-app-height modal-mask  overflow-y-auto flex">
      <div className="w-full h-fit mx-4 bg-white rounded-16x">
        <form
          className="py-8 px-4 xs:px-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="">
            <p className="mb-6 text-16x text-center">{t(title)}</p>
          </div>
          {dynamicText && (
            <div className="mb-6 text-16x text-center">{dynamicText}</div>
          )}
          <div className="grid grid-cols-2 gap-3">
              <CustomButton
                type="button"
                onClick={handleClickNo}
                outline
                className="w-full capitalize"
                title={t("no")}
                style={{
                  borderRadius: "16px"
                }}
              />
          
              <CustomButton
                  type="button"
                  onClick={handleClickYes}
                  title={t("yes")}
                  className="w-full capitalize"
                  style={{
                    borderRadius: "16px"
                  }}
                />
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangeActionPopup;
